import React, { useState, createContext, useContext, useEffect } from 'react';
import { Formik } from 'formik';
import { FastField } from 'formik';
import { Card, CardContent, Button, TextField, Box, Typography, Container, Avatar } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { fetchJSON, setAuthFailed } from './fetch';
import { setCookie, removeCookie } from './cookie';
import { useSnackbar } from 'notistack';
import { theme } from '../config.json';

const AuthCtx = createContext();

export function AuthProvider({ children }) {
  let cred = localStorage.getItem('cred');
  if (cred) {
    cred = JSON.parse(cred);
  } else {
    cred = { token: false, user: false };
  }
  const [user, setUser] = useState(cred);
  const [module, setModule] = useState(false);
  function login(payload, module) {
    localStorage.setItem('cred', JSON.stringify(payload));
    setCookie('token', payload.token, 2);
    setUser(payload);
    setModule(module);
    document.body.dispatchEvent(new CustomEvent('CLEAR_CACHE'));
  }

  function logout() {
    setUser(false);
    localStorage.setItem('cred', '');
    removeCookie('token');
    document.body.dispatchEvent(new CustomEvent('CLEAR_CACHE'));
  }
  setAuthFailed(logout);

  return <AuthCtx.Provider value={{ user, login, logout, module, setModule }} > {children}</ AuthCtx.Provider>
}


function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      Fontis Software Kft.
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

function Login({ login, background, title, module }) {
  const { enqueueSnackbar } = useSnackbar();

  const onSubmit = async (value) => {
    let res = await fetchJSON('POST', '/login', value);
    if(!res || ! res.token){
      enqueueSnackbar('Érvénytelen felhasználónév vagy jelszó', { variant: 'error' });
    }else{
      const { user, token, munkakor, reszleg, salesperson, ceg, nev, tel, email, raktaros, admin, beszerzo } = res;
      login({ user, token, munkakor, reszleg, raktaros, admin, salesperson, ceg, nev, tel, email, beszerzo }, module);
    }
  };

  return <div style={{
    background: '#ccc',
    backgroundImage: `url(${background})`,
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    width: '100vw',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
    <Container component="main" maxWidth="xs">


      <Card >
        <Box
          sx={{
            marginTop: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            {title}
          </Typography>
          <CardContent>
            <Formik initialValues={{ login: '', psw: '' }} onSubmit={onSubmit}>
              {props => (
                <Box component="form" onSubmit={props.handleSubmit} noValidate sx={{ mt: 1 }}>
                  <FastField name="login">{({ field }) => <TextField fullWidth required margin="normal" autoFocus label="Felhasználói név" {...field} />}</FastField>
                  <FastField name="psw">{({ field }) => <TextField fullWidth required margin="normal" type="password" label="Jelszó" {...field} />}</FastField>
                  <div style={{ textAlign: 'right' }}>
                    <Button variant="contained" type="submit" fullWidth sx={{ mt: 3, mb: 2 }}>Belépés</Button>
                  </div>
                </Box>
              )}
            </Formik>
          </CardContent>
        </Box>
      </Card>
      <Copyright sx={{ mt: 8, mb: 4 }} />
    </Container>
  </div>
}

export function useAuth() {
  return useContext(AuthCtx);
}

export function Protected({ allowed, children, background, title, module }) {
  const { user, logout, login, module: m, setModule } = useAuth();
  if (!background && theme) background = theme.login;
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (m !== module) {
      setModule(module);
    }
  }, [m, setModule, module]);

  //  console.log("Van user", user, allowed);

  useEffect(() => {
    if (user && user.user && allowed && !allowed(user)) {
      enqueueSnackbar('Ehhez a felülethez nincs jogosultsága', { variant: 'error' });
      logout();
    }
  }, [user, allowed, logout]);

  if (user && user.user) {
    return children;
  }

  return <Login login={login} background={background || '/login.jpg'} title={title || 'Bejelentkezés'} module={module} />
}
